import App from './modules/app';

const app = new App();

export default app;
